import type { PaymentMethodsAll } from '@mobi/component-library/Deposit/types'
import { paymentMethodTypeNameMap } from '../Areas/Deposit/Utils/schema'
import type { DepositAnalyticsKeys } from '../Areas/Deposit/typings/types'
import type { WithdrawAnalyticsKeys } from '../Areas/Withdraw/typings/types'
import type { SignUpAnalyticsKey } from '../Areas/SignUp/Utils/ga'
import type { VerificationAnalyticsKey } from '../Areas/Verification/Utils/ga'

type AnalyticsEventData = {
  accountNumber?: number
  paymentMethod?: PaymentMethodsAll
  [key: string]: unknown
}

export type EventKey =
  | DepositAnalyticsKeys
  | WithdrawAnalyticsKeys
  | SignUpAnalyticsKey
  | VerificationAnalyticsKey

export type TrackAnalytics = (eventKey: EventKey, data?: AnalyticsEventData) => void

export const track: TrackAnalytics = (eventKey, data = {}) => {
  const { accountNumber, paymentMethod, ...other } = data
  window.dataLayer?.push({
    event: eventKey,
    accountNumber,
    ...(paymentMethod && { depositMethod: paymentMethodTypeNameMap[paymentMethod] }),
    ...other,
  })
}
